module.exports = __webpack_public_path__ + "static/media/mobilesorting.80ebcb54.svg";